import { AnimationBaseController, IAnimationControllerConfiguration, Inject } from '@denishussar/html5-game-engine';
import { GameLogic } from '../../../Logic/GameLogic';
import { RopesModel } from '../../../Models/MiniGames/RopesModel';

export interface IPropsDialogButtonControllerOptions {
    onClick: () => void;
}

export class PropsButtonController extends AnimationBaseController {
    $model: RopesModel;

    public constructor(
        @Inject private _options: IPropsDialogButtonControllerOptions,
        @Inject private _gameLogic: GameLogic,
    ) {
        super('PropsDialogButtonController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return {
            onPointerDown: e => {
                this._options.onClick();
            },
            onPointerOver: () => {
                this.gotoAndStop('hover');
            },
            onPointerOut: () => {
                this.gotoAndStop('active');
            },
        };
    }

    protected onInitialize(): void {
    }

    protected onResize(width: number, height: number, scale: number): void {
    }
}
